import { createSelector } from 'reselect';

const selectScheduledTasks = (state: any) => state.scheduledTasks;


export const selectScheduledTasksCurrentItem = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.current);

export const selectScheduledTasksListItems = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.list);

export const selectScheduledTasksItemById = (itemId: any) =>
    createSelector(selectScheduledTasksListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectScheduledTasksQueryItems = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.query);

export const selectScheduledTasksCreatedItem = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.create);

export const selectScheduledTasksUpdatedItem = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.update);

export const selectScheduledTasksReadItem = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.read);

export const selectScheduledTasksDeletedItem = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.delete);

export const selectScheduledTasksearchedItems = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.search);

export const selectScheduledTasksItemsCount = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.count);

export const selectScheduledTasksItemsFilter = createSelector([selectScheduledTasks], (scheduledTasks) => scheduledTasks.filter);